export const managersConstants = {
  MANAGERS_DATA: "MANAGERS_DATA",
  MANAGERS_DATA_UPDATE: "MANAGERS_DATA_UPDATE",
  FILTER_MANAGERS_DATA: "FILTER_MANAGERS_DATA",
  MANAGERS: "MANAGERS",
  RESET_MANAGERS: "RESET_MANAGERS",
  MANAGERS_DETAIL: "MANAGERS_DETAIL",
  PAGINATED_MANAGERS_DATA: "PAGINATED_MANAGERS_DATA",
  GET_ALL_LOCATIONS: "GET_ALL_LOCATIONS_FOR_MANAGER",
  AND: " AND ",
  OR: " OR ",
  STATE: "state",
  NAME: "name",
  OWNER_NAME: "ownerName",
  UPDATE_MANAGERS: "UPDATE_MANAGERS",
  UPDATE_MANAGERS_RESPONSE: "UPDATE_MANAGERS_RESPONSE",
  MANAGERS_USER_ADD_ERROR:
    "Please create a user for this manager first to activate the manager!",
  CREATE_SYSTEM_USER: "_createSystemUser",
  MANAGERS_UPDATED_FLAG: "MANAGER_UPDATED_FLAG",
};

export const MANAGERS_LABELS = {
  NAME: "NAME",
  STORES: "STORES",
  ACTIONS: "ACTIONS",
  CONFIRM: "Confirm",
  NO_MANAGER_FOUND: "No Manager Found",
  NO_LOCATIONS: "It has no locations",
};
